export function Title({ children }: { children: string }) {
	return <h2 className="text-h2 sm:text-h1">{children}</h2>
}
